<sb-card>
  <div card-header>
    <h3>{{'lang.globals.overview' | translate}}</h3>
  </div>
  <div card-body>
    <div class="row">
      <div class="col-4">
        <div class="flex-grow-1 w-100">
          <div class="d-flex align-items-center w-100 ">
            <div>
              <h4>{{company?.name ? company?.name : company?.identifier}}</h4>
              <h6>{{'lang.globals.id' | translate}}: {{company?.id}}</h6>
            </div>
          </div>
          <div class="mt-4">
            <h5 class="mb-2">{{'lang.address.information:' | translate}}</h5>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.street:' | translate}}</span><span
              class="text-muted"> {{company?.address?.street}} {{company?.address?.street2}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">
                {{'lang.globals.zip:' | translate}} / {{'lang.globals.city:' | translate}}
              </span>
              <span class="text-muted">
               {{company?.address?.zip}} {{company?.address?.city}}
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.state:' | translate}}</span><span
              class="text-muted"> {{company?.address?.state}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">
                {{'lang.globals.country:' | translate}}
              </span>
              <span class="text-muted">
                {{company?.address?.country}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <sb-map [drawing]="false" [mapHeight]="470"
                [showSinglePoint]="getSelectedCompanyCoords()"></sb-map>
      </div>
    </div>
  </div>
</sb-card>
